import React,{Component} from 'react';

import { Button} from "react-bootstrap";
import { changePassword } from "../../services/GameServices";
class ChangeP extends Component {
    constructor(props){
        super(props);
        this.state={
            name:'',
            pass:'',
            con:''
        }
    }
    componentDidMount(){
      console.log("Change password component");
    }
    handleNameChange= (e)=> {
        this.setState({ name: e.target.value });
      }
    handlePassChange= (e)=> {
    this.setState({ pass: e.target.value });
    }
    handleConfirmChange= (e)=> {
      this.setState({ con: e.target.value });
      }
    error = () => {
        console.log('Password combination is incorrect');
        alert('Passwords are not the same');
    }
    authenticate = () => {
        
        let uname=localStorage.getItem("NAME");
        
        let pold=localStorage.getItem("PASS");
        console.log("Checkinsfg");
        let hist= this.props.history;
        if(this.state.name ===pold && (this.state.con ===this.state.pass)){
          changePassword({
            username:uname,
            oldp: this.state.name,
            newp: this.state.pass
          }).then(function(resp, err) {
            if (err) {
              console.log("an error");
              console.log(err);
              this.error();
              //call error message 
            } 
            else if (resp) {
              if (resp.data.err) {
                console.log("response error", resp.data.err);
                this.error();
              } 
              else {
                console.log("response is cool ", resp.data.data);
                //print response and get token and save it
                //token is in resp.data.data
                let token = resp.data.data;
                localStorage.setItem("PASS", token);
                hist.push({
                    pathname:`/`
                  });
                
              }
              console.log(resp);
            } 
            else {
              console.log("No response what so ever");
              this.error();
            }
          }).catch(err =>{
            console.log("trouble Changing password " ,err);
            this.error();
        })
        }
        else{
          this.error();
        }
      
        
      }
    render(){
        return(
            <div style={{textAlign:"center"}}> 
                <h2> 
                  Change password
                </h2>
                <div style={{ padding: 20 }}>
                    <h3>Old Password</h3>
                    <input type="text" placeholder="Old Password"
                        onChange={this.handleNameChange}  />
                    <h3>New Password</h3>
                    <input type="password" placeholder="New Password"
                        onChange={this.handlePassChange}  />
                        
                    <h3>Confirm Password</h3>
                    <input type="password" placeholder="Confirm Password"
                        onChange={this.handleConfirmChange}  />
                    <br />
                    <Button style={{ marginTop: 17 }} bsSize="large" bsStyle="info" onClick={this.authenticate}>Change</Button>
                </div>

            </div>
        )
    }
}
export default ChangeP;


// WEBPACK FOOTER //
// ./src/views/Quiz/ChangeP.jsx